<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :options.sync="options"
      :server-items-length="head.count"
      class="elevation-1"
      :loading="loading"
      :footer-props="{
        'items-per-page-options':[5, 10, 30],
        'items-per-page-text': ''
      }"
      must-sort
      item-key="id"
      :expanded.sync="expanded"
      show-expand
      locale="ko"
      @item-expanded="expandedItem"
    >
      <template v-slot:item.createdAt="{ item }">
        <!-- {{item.createdAt.toLocaleTimeString()}} -->
        <display-time :time="item.createdAt" />
      </template>
      <template v-slot:item.email="{ item }">
        <v-chip color="primary">
          <v-avatar left>
            <v-img v-if="item.photoURL" :src="item.photoURL"></v-img>
            <v-icon v-else>mdi-lock-open</v-icon>
          </v-avatar>
          {{item.email}}
        </v-chip>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" style="white-space: pre" class="pa-4">
          <v-card>
            <v-subheader>
              내용
              <v-spacer />
              <v-btn color="warning" icon @click="openDialog(item)"><v-icon>mdi-pencil</v-icon></v-btn>
              <v-btn color="error" icon @click="remove(item)"><v-icon>mdi-delete</v-icon></v-btn>
            </v-subheader>
            <!-- <div class="pa-4">
              <v-sheet v-html="item.content"></v-sheet>
            </div> -->
            <v-card-text v-if="item.content && !loading">
              <viewer :initialValue="item.content" v-if="!dialog && !loading" :options="tuiOptions"></viewer>
            </v-card-text>
            <v-card-text v-else>
              <v-skeleton-loader type="card"></v-skeleton-loader>
            </v-card-text>
            <v-card-actions>
              <v-spacer/>
              <span class="font-italic">수정: <display-time :time="item.updatedAt" /></span>
            </v-card-actions>
            <v-divider/>
            <comment :article="item" :id="item.id" :refArticle="refArticle"></comment>
          </v-card>
        </td>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog">
      <v-form v-model="valid" ref="form">
        <v-card :loading="loading">
          <v-card-title>
            글작성
            <v-spacer/>
            <v-btn @click="save" icon><v-icon>mdi-content-save</v-icon></v-btn>
            <v-btn @click="closeDialog" icon><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-text-field v-model="form.title" outlined label="제목" :rules="[rule.required, rule.maxLength(80)]" required clearable />
            <editor :initialValue="form.content" ref="editor" :options="tuiOptions" height="600px"></editor>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import 'highlight.js/styles/github.css'
import { head, last } from 'lodash'
import Comment from '@/components/comment'
import DisplayTime from '@/components/display-time'
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight'
import hljs from 'highlight.js/lib/highlight'
import javascript from 'highlight.js/lib/languages/javascript'
import bash from 'highlight.js/lib/languages/bash'
import dart from 'highlight.js/lib/languages/dart'
import vue from 'vue-highlight.js/lib/languages/vue'

hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('bash', bash)
hljs.registerLanguage('dart', dart)
hljs.registerLanguage('vue', vue)

export default {
  components: { Comment, DisplayTime },
  props: ['head', 'collection', 'content', 'dialogState'],
  data () {
    return {
      tuiOptions: {
        language: 'ko',
        plugins: [[codeSyntaxHighlight, { hljs }]],
        linkAttribute: {
          target: '_blank'
        }
      },
      refArticle: null,
      unsubscribe: null,
      loading: false,
      dialog: false,
      valid: false,
      docs: [],
      headers: [
        { text: '작성시간', value: 'createdAt' },
        // { text: '수정시간', value: 'updatedAt' },
        { text: '제목', value: 'title' },
        { text: '작성자', value: 'email' },
        { text: '조회수', value: 'countRead' },
        { text: '댓글', value: 'countComment' },
        // { text: '좋아요', value: 'countLike' },
        { text: '내용', value: 'data-table-expand' }
      ],
      items: [],
      totalCount: 0,
      options: {
        sortBy: ['createdAt'],
        sortDesc: [true]
      },
      expanded: [],
      form: {
        title: '',
        content: ''
      },
      selectedItem: null,
      rule: {
        required: v => !!v || '필수 항목입니다.',
        minLength: length => v => v.length >= length || `${length}자리 이상으로 입력하세요.`,
        maxLength: length => v => v.length <= length || `${length}자리 이하으로 입력하세요.`
      }
    }
  },
  watch: {
    options: {
      handler (n, o) {
        if (!o.page) {
          this.subscribe(0)
          return
        }
        const arrow = n.page - o.page
        this.subscribe(arrow)
      },
      deep: true
    },
    content (n, o) {
      this.subscribe()
    },
    dialogState (n, o) {
      if (n) this.openDialog()
      else this.dialog = false
    }
  },
  created () {
    // this.subscribe()
  },
  destroyed () {
    if (this.unsubscribe) this.unsubscribe()
  },
  methods: {
    onError (e) {
      this.loading = false
      this.$toast.error(e.message)
    },
    subscribe (arrow) {
      this.refArticle = this.$firebase.firestore()
        .collection(this.collection)
        .doc(this.content)
        .collection('articles')
      const order = this.options.sortBy[0]
      const sort = this.options.sortDesc[0] ? 'desc' : 'asc'
      const limit = this.options.itemsPerPage
      const ref = this.refArticle.orderBy(order, sort)
      let query
      switch (arrow) {
        case -1: query = ref.endBefore(head(this.docs)).limitToLast(limit)
          break
        case 1: query = ref.startAfter(last(this.docs)).limit(limit)
          break
        default: query = ref.limit(limit)
          break
      }
      this.loading = true
      this.unsubscribe = query.onSnapshot((sn) => {
        if (sn.empty) {
          this.items = []
          this.loading = false
          return
        }
        this.docs = sn.docs
        const items = sn.docs.map(doc => {
          const item = doc.data()
          item.id = doc.id
          item.createdAt = item.createdAt.toDate()
          item.updatedAt = item.updatedAt.toDate()
          const filteredItem = this.items.filter((v) => v.id === item.id)
          if (filteredItem.length && filteredItem[0].content) {
            item.content = filteredItem[0].content
            // console.log(filteredItem)
          }
          // console.log(item.content)
          return item
        }, this.onError)
        this.items = items
        this.loading = false
      })
    },
    openDialog (item) {
      this.dialog = true
      if (this.$refs.form) this.$refs.form.resetValidation()
      this.selectedItem = item
      if (!item) {
        this.form.title = ''
        this.form.content = ''
      } else {
        this.form.title = item.title
        if (item.content) this.form.content = item.content
      }
    },
    async save () {
      if (!this.$refs.form.validate()) return
      const head = {
        title: this.form.title,
        updatedAt: new Date()
      }
      const body = {
        content: this.$refs.editor.invoke('getMarkdown')
      }

      if (!body.content.length) throw Error('내용을 채워주세요')
      if (body.content.length > 10000) throw Error('10000자 이상은 허용하지 않습니다.')
      if (body.content.length > 10000) throw Error('10000자 이상은 허용하지 않습니다.')
      this.loading = true
      try {
        if (this.selectedItem) {
          this.selectedItem.content = body.content
          await this.refArticle.doc(this.selectedItem.id).update(head)
          await this.refArticle.doc(this.selectedItem.id).collection('content').doc('last').update(body)
        } else {
          const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : null
          const email = this.$store.state.fireUser ? this.$store.state.fireUser.email : null
          const photoURL = this.$store.state.fireUser ? this.$store.state.fireUser.photoURL : null
          head.createdAt = new Date()
          head.countRead = 0
          head.countLike = 0
          head.email = email
          head.uid = uid
          head.photoURL = photoURL
          head.countComment = 0
          body.uid = uid
          const doc = await this.refArticle.add(head)
          await this.refArticle.doc(doc.id).collection('content').doc('last').set(body)
        }
      } finally {
        this.loading = false
        this.closeDialog()
      }
    },
    async remove (item) {
      const r = await this.$swal.fire({
        title: '정말 삭제하시겠습니까?',
        text: '삭제 후 되돌릴 수 없습니다.',
        icon: 'error',
        // confirmButtonText: 'Cool',
        showCancelButton: true
      })
      if (!r.value) return
      this.loading = true
      try {
        await this.refArticle.doc(item.id).collection('content').doc('last').delete()
        await this.refArticle.doc(item.id).delete()
      } finally {
        this.loading = false
        this.subscribe(0)
      }
    },
    async getContent (item) {
      const doc = await this.refArticle.doc(item.id).collection('content').doc('last').get()
      item.content = doc.data().content
      await this.refArticle.doc(item.id).update({
        countRead: this.$firebase.firestore.FieldValue.increment(1)
      })
    },
    expandedItem (props) {
      if (props.value) this.getContent(props.item)
    },
    closeDialog () {
      this.$emit('close-dialog')
      this.dialog = false
    }
  }
}
</script>
